import { Button, Paper, Stack, Typography } from "@mui/material";

export default function HardwareCard({
  eyebrow,
  title,
  desc,
  priceText,
  actions = [],
  highlight = false,
  onAction, // (intent) => void  — اختياري/احتياطي
}) {
  return (
    <Paper
      elevation={0}
      variant="outlined"
      sx={{
        p: { xs: 2, md: 2.5 },
        borderRadius: 1,
        height: "100%",
        display: "grid",
        alignContent: "start",
        gap: 2,
        bgcolor: "common.white",
        boxShadow: "0 10px 28px rgba(8, 28, 78, .06)",
        ...(highlight && {
          borderColor: "primary.main",
          boxShadow: "0 14px 40px rgba(84,49,152,.14)",
        }),
      }}
    >
      {/* سطر علوي صغير */}
      {eyebrow && (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ opacity: 0.85 }}
        >
          {eyebrow}
        </Typography>
      )}

      {/* العنوان */}
      <Typography
        component="h3"
        sx={{
          fontWeight: 900,
          color: "primary.dark",
          fontSize: { xs: 20, md: 22 },
        }}
      >
        {title}
      </Typography>

      {/* الوصف */}
      <Typography color="text.secondary" sx={{ lineHeight: 1.9 }}>
        {desc}
      </Typography>

      {/* السعر (اختياري) */}
      {/* {priceText && (
        <Typography sx={{ fontWeight: 900, color: "success.main" }}>
          {priceText}
        </Typography>
      )} */}

      {/* الأزرار */}
      {actions.length > 0 && (
        <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
          {actions.map((a) => {
            const isHref = !!a.href;
            const commonProps = {
              key: a.label,
              variant: a.variant || "contained",
              color: a.color || (highlight ? "success" : "primary"),
              sx: { fontWeight: 800, minWidth: 140 },
            };

            // لو فيه href نفتح الرابط مباشرة
            if (isHref) {
              return (
                <Button
                  {...commonProps}
                  component="a"
                  href={a.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {a.label}
                </Button>
              );
            }

            // احتياطيًا: إن وُجد intent بدون href
            return (
              <Button {...commonProps} onClick={() => onAction?.(a.intent)}>
                {a.label}
              </Button>
            );
          })}
        </Stack>
      )}
    </Paper>
  );
}
